var bannerPartners;
function repositionPartners() {
  if ($(".js-partners-block").length) {
    bannerPartners = $(".js-partners-block").clone();
    if ($(".in-index").length == 0) {
      var footerServiceItem = $(".js-partners-block").closest(".banner");
      var partnersBlock = $(".js-partners-block");
      footerServiceItem.parent().remove();
      partnersBlock.insertBefore(".js-instagram-block");
    } else {
      $(".js-partners-block").closest(".banner").parent().remove();
    }
  }
}
